import qs from 'qs';
import env from '@/env';

import tokenApiClientV7 from './token-api-client-v7';

// import activateAccountApiClient from './activate-account-client';
import createAuthorizedApiClient, { AuthTokenType } from '../authorized-api-client';

const authorizedApiClient = createAuthorizedApiClient(
  env.api.baseUrl.identityService,
  AuthTokenType.AccessToken,
);

class AuthService {
  signInWithOAuth = async (data: any) => {
    const body = qs.stringify(data);
    const response = await tokenApiClientV7.post('/oauth2/token', body);
    return response.data;
  };

  obtainToken = async (clientId: string, clientSecret: string) => {
    const body = qs.stringify({
      grant_type: 'client_credentials',
    });
    const response = await tokenApiClientV7.post('/oauth2/token', body, {
      auth: {
        username: clientId,
        password: clientSecret,
      },
    });
    return response.data;
  };

  logOutOAuth = async () => {
    window.location.href = `${env.api.baseUrl.tokenBaseUrl}logout?client_id=${env.app.authCodeAppId}&logout_uri=${env.rootUrl}`;
    return null;
  };

  inviteUserToOrganization = async (
    emailAddress: string,
    organisationDomain: string,
    memberships: { roleName: string; organisationId: string },
  ) => {
    const body = [
      {
        emailAddress,
        organisationDomain,
        memberships,
      },
    ];
    const response = await authorizedApiClient.post('users/-/invitations', body, {
      headers: {
        callbackUrl: `${env.rootUrl}/auth/register`,
        isOrganizationOwner: true,
      },
    });
    return response.data;
  };

  fetchInvitations = async () => {
    const response = await authorizedApiClient.get('users/-/invitations');
    return response.data;
  };
}

const instance = new AuthService();
export default instance;
export { default as authHelpers } from './helpers';
